import React, { useEffect, useState } from 'react';
import { Table, Button, Drawer, Space, Popconfirm, message, Card, Input } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import useMessage from 'antd/es/message/useMessage';
import dayjs from 'dayjs';
import AddGenerator from './AddGenerator';

const ViewGenerator = () => {
    const [data, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const [message, smsgContext] = useMessage();


    const getAllServices = async () => {
        try {
            const request = await ServicetypeService.getAllGenerator();

            console.log(request);

            const formattedData = request.data.map((item, index) => ({
                ...item,
                si_no: index + 1,
                key: item.id,
            }));

            setData(formattedData);
            setOriginalData(formattedData);

        } catch (error) {
            console.error(error);

        }
    };
    useEffect(() => {
        getAllServices();
    }, [])


    // Open drawer for Add
    const handleAdd = () => {
        setEditingRecord(null);
        setDrawerOpen(true);
    };

    // Open drawer for Edit
    const handleEdit = (record) => {
        setEditingRecord(record);
        setDrawerOpen(true);
    };

    // Handle form submit (add or edit)
    const handleSubmit = (values) => {
        if (editingRecord) {
            // Edit existing
            setData((prev) =>
                prev.map((item) =>
                    item.key === editingRecord.key ? { ...item, ...values } : item
                )
            );
            getAllServices();
        } else {
            // Add new
            const newRecord = {
                key: Date.now().toString(),
                ...values,
                added_on: new Date().toISOString().slice(0, 16).replace("T", " "),
                updated_on: new Date().toISOString().slice(0, 16).replace("T", " "),
            };
            setData((prev) => [...prev, newRecord]);
            getAllServices();
        }
        setDrawerOpen(false);
    };


    const handleDelete = async (key) => {
        console.log(key);

        try {
            const req = await ServicetypeService.deleteproductCat(key);

            if (req.status) {
                message.success(req.message)
                getAllServices();
                setData((prev) => prev.filter((item) => item.key !== key));
            } else {
                message.error(req.message)
            }
        } catch (error) {
            console.log(error);
        }
    };

    const columns = [
        { title: 'S. No', dataIndex: 'si_no', key: 'si_no' },
        {
            title: 'Generator Name', dataIndex: 'name', key: 'name',
            width: 650,
            render: (text) => (
                <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {text}
                </div>
            ),
        },
        { title: 'HSN/SAC Code', dataIndex: 'sku', key: 'sku' },
        // { title: 'status', dataIndex: 'status', key: 'status' },
        // { title: 'Added By', dataIndex: 'added_by', key: 'added_by' },
        // { title: 'Updated On', dataIndex: 'updated_on', key: 'updated_on', render: (value) => dayjs(value).format("DD-MM-YYYY hh:mm A") },
        {
            title: 'Updates', dataIndex: 'added_on', key: 'added_on', render: (_, record) => (
                <div>
                    <div>
                        <strong>Added On:</strong>{" "}
                        {record.added_on
                            ? dayjs(record.added_on).format("DD-MM-YYYY hh:mm A")
                            : "-"}
                    </div>
                    <div>
                        <strong>Updated On:</strong>{" "}
                        {record.updated_on
                            ? dayjs(record.updated_on).format("DD-MM-YYYY hh:mm A")
                            : "-"}
                    </div>
                </div>
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            fixed: 'right',
            render: (_, record) => (
                <Space>
                    <Button
                        size='large'
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record)}
                    />
                    <Popconfirm
                        title="Are you sure to delete?"
                        onConfirm={() => handleDelete(record.id)}
                    >
                        <Button size='large' danger icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const handleSearch = (value) => {
        setSearchText(value);

        if (!value) {
            setData(originalData);
            return;
        }

        const filteredData = originalData.filter((item) =>
            Object.values(item).some((field) =>
                field
                    ?.toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
            )
        );

        setData(filteredData);
    };

    return (
        <Card
            title='Manage Generators'
            extra={
                <Space>

                    <Input
                        size="large"
                        placeholder="Search product generators..."
                        style={{ width: 350 }}
                        value={searchText}
                        onChange={(e) => handleSearch(e.target.value)}
                        allowClear
                    />

                    <Button
                        size='large'
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleAdd}
                    >
                        Add Generators
                    </Button>
                </Space>
            }>

            <Table
                columns={columns}
                dataSource={data}
                // 
                pagination={{ pageSize: 7 }}
                scroll={{ x: 'max-content' }}
            />
            {smsgContext}

            <Drawer
                title={editingRecord ? 'Edit Generator' : 'Add Generator'}
                width={900}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                destroyOnClose
            >
                <AddGenerator
                    initialValues={editingRecord}
                    onSubmit={handleSubmit}
                    onCancel={() => setDrawerOpen(false)}
                />
            </Drawer>
        </Card>
    );
};

export default ViewGenerator;
